export default "__VITE_ASSET__CMqsKvPh__"